import { createApolloClient } from '../lib/createApolloClient'
import { DefaultSeo } from 'next-seo'
import '../styles/base.css'
import GlobalContextProvider from 'context/GlobalContextProvider'
import SEOSelect from 'next-seo-select.config'
import SEOModellink from 'next-seo-modellink.config'
import isModellinkSite from '../helpers/isModellinkSite'
import { ApolloProvider } from '@apollo/client/react'

function App({ Component, pageProps, apollo }) {
  const SEO = isModellinkSite() ? SEOModellink : SEOSelect

  const client = createApolloClient()

  return (
    <ApolloProvider client={client}>
      <DefaultSeo {...SEO} />
      <GlobalContextProvider>
        <Component {...pageProps} />
      </GlobalContextProvider>
    </ApolloProvider>
  )
}

export default App
